import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface HandleEnvTypeParamProps {
  env: string;
  setEnv: React.Dispatch<React.SetStateAction<string>>;
}

const HandleEnvTypeParam: React.FC<HandleEnvTypeParamProps> = ({
  env,
  setEnv,
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const envType = queryParams.get("envType");
  useEffect(() => {
    if (envType && env !== envType.toUpperCase()) {
      setEnv(envType.toUpperCase()); // Update env if it doesn't match the current one
    }
  }, [envType, env]);

  return null; // Component doesn't render anything, but could log or show something
};

export default HandleEnvTypeParam;
